import { useTranslation } from "react-i18next";
import { useScrollThreshold } from "@/hooks/useScrollThreshold";
import { HeaderAuthActions } from "@/components/Layout/header/HeaderAuthActions";
import { HeaderBrand } from "@/components/Layout/header/HeaderBrand";
import { HeaderMobileMenu } from "@/components/Layout/header/HeaderMobileMenu";
import { HeaderMobileToggle } from "@/components/Layout/header/HeaderMobileToggle";
import { HeaderNavigation } from "@/components/Layout/header/HeaderNavigation";
import { HeaderPreferenceControls } from "@/components/Layout/header/HeaderPreferenceControls";
import { useHeaderMobileMenu } from "@/components/Layout/header/useHeaderMobileMenu";
import "./Header.css";

export function Header() {
  const { t } = useTranslation();
  const scrolled = useScrollThreshold(10);
  const mobileMenu = useHeaderMobileMenu();

  return (
    <header
      className={`site-header ${scrolled ? "site-header--scrolled" : ""} ${mobileMenu.open ? "site-header--menu-open" : ""}`}
    >
      <div className="site-header__inner">
        <HeaderBrand />

        <div className="site-header__center">
          <nav className="site-header__nav" aria-label={t("a11y.primaryNav")}>
            <HeaderNavigation variant="desktop" />
          </nav>
        </div>

        <div className="site-header__actions">
          <HeaderPreferenceControls variant="desktop" />
          <HeaderAuthActions size="sm" />

          <HeaderMobileToggle
            ref={mobileMenu.toggleRef}
            open={mobileMenu.open}
            onClick={mobileMenu.toggle}
          />
        </div>
      </div>

      {mobileMenu.open && (
        <HeaderMobileMenu
          ref={mobileMenu.menuRef}
          onNavigate={mobileMenu.close}
        />
      )}
    </header>
  );
}
